import React from 'react';

const PlayIcon = ({ width = 34, height = 34, color, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14.4167 22.9167L22.5417 17.7083C22.9306 17.4583 23.125 17.1111 23.125 16.6667C23.125 16.2222 22.9306 15.875 22.5417 15.625L14.4167 10.4167C14 10.1389 13.5764 10.1181 13.1458 10.3542C12.7153 10.5903 12.5 10.9583 12.5 11.4583V21.875C12.5 22.375 12.7153 22.7431 13.1458 22.9792C13.5764 23.2153 14 23.1944 14.4167 22.9167ZM16.6667 33.3333C14.3611 33.3333 12.1944 32.8958 10.1667 32.0208C8.13889 31.1458 6.375 29.9583 4.875 28.4583C3.375 26.9583 2.1875 25.1944 1.3125 23.1667C0.4375 21.1389 0 18.9722 0 16.6667C0 14.3611 0.4375 12.1944 1.3125 10.1667C2.1875 8.13889 3.375 6.375 4.875 4.875C6.375 3.375 8.13889 2.1875 10.1667 1.3125C12.1944 0.4375 14.3611 0 16.6667 0C18.9722 0 21.1389 0.4375 23.1667 1.3125C25.1944 2.1875 26.9583 3.375 28.4583 4.875C29.9583 6.375 31.1458 8.13889 32.0208 10.1667C32.8958 12.1944 33.3333 14.3611 33.3333 16.6667C33.3333 18.9722 32.8958 21.1389 32.0208 23.1667C31.1458 25.1944 29.9583 26.9583 28.4583 28.4583C26.9583 29.9583 25.1944 31.1458 23.1667 32.0208C21.1389 32.8958 18.9722 33.3333 16.6667 33.3333Z" fill={color || "#735FE3"} />
  </svg>
);

export default PlayIcon;